var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.images
    ? _c("div", { staticClass: "product-gallery" }, [
        _c("div", {
          staticClass: "feature",
          style: `background: url(${
            _vm.firstImage.url
          }) no-repeat center center / cover; 
                        flex-basis:${100 / (_vm.images.length - 1)}%;
                        background-size:${!_vm.isZooming ? "cover" : "300%"};
                        background-position:${_vm.x}% ${_vm.y}%`,
          on: {
            mouseover: function ($event) {
              _vm.isZooming = true
            },
            mousemove: function ($event) {
              return _vm.zoomOnCursor($event)
            },
            mouseleave: function ($event) {
              _vm.isZooming = false
              _vm.x = 50
              _vm.y = 50
            },
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "additional-images" },
          _vm._l(_vm.images, function (image) {
            return _c("div", {
              key: image.ID,
              staticClass: "image",
              style: `background: url(${
                image.url
              }) no-repeat center center / cover; 
                           flex-basis:calc(${100 / _vm.images.length}% - 2.5px);
                           padding-bottom:${100 / _vm.images.length}%;
                           `,
              attrs: { src: image.url, alt: image.alt },
              on: {
                click: function ($event) {
                  return _vm.switchImage(image)
                },
                mouseover: function ($event) {
                  return _vm.switchImage(image)
                },
              },
            })
          }),
          0
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/components/ProductGallery.vue